import { fillLayers, pick, titleCase, type LayerStyle } from "./types";

const RECHARGE = "#2c85b1";

const style: LayerStyle = {
  id: "edwards-recharge",
  minzoom: 8,
  maxzoom: 14,
  layers(source) {
    return fillLayers(this, source, RECHARGE, 0.25);
  },
  legend: [{ label: "Recharge zone", color: RECHARGE }],
  describe: (p) => pick(p, [["RECHARGE_ZONE", "Recharge zone segment", titleCase]]),
};

export default style;
